const initialState = {
  show: false,
  gateway: null,
};

const maintenanceModalState = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  switch (action.type) {
    case 'MAINTENANCE_MODAL_SET_STATE':
      return {
        ...state.maintenanceModalState,
        ...action.payload,
      };
    case 'MAINTENANCE_MODAL_RESET':
      return initialState;
    default:
      return state.maintenanceModalState || initialState;
  }
};

export { maintenanceModalState };
